import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import { IS_JEWLR } from "helpers/application"

import SocialShare from "./social-share"
import WizardActions from "./wizard-actions"
import HeaderDesktop from "./wizard-header/header-desktop"
import WizardOptions from "./wizard-options"

const Container = styled(Box).attrs((props) => ({
  bg: { _: "grey.4", tablet: "transparent" },
  borderTop: `1px solid ${props.theme.colors.grey[10]}`,
  p: { _: "18px 16px", tablet: "16px 0 0 " },
}))``

const MainBody = ({ outOfStockRef }) => (
  <div>
    <HeaderDesktop />
    <WizardOptions />
    <Container>
      <WizardActions outOfStockRef={outOfStockRef} />
      {IS_JEWLR() && <SocialShare />}
    </Container>
  </div>
)

MainBody.propTypes = {
  outOfStockRef: PropTypes.object,
}

export default MainBody
